<div class="challenges-top-area d-flex m-2 mt-3" style="transition: none;">
    <button type="button" class="challenges-back-button btn btn-text-gray btn-icon" (click)="cs.currentView = 0">
        <svg><use href="../App_Themes/clearview-default/icons/utility/arrow-left.svg#arrow-left"></use></svg>
        <span cvLocalizedText langSection="Common" langKey="Back_Button">Back</span>
    </button>
</div>

<div class="content p-2 mt-3 mx-auto" style="max-width: 1050px;">
    <div class="challengeHistoryList mx-auto">
        <div class="row mb-3">
            <div class="col-7">
                <h8 cvLocalizedText langSection="Challenges" langKey="Challenge_History">Challenge History</h8>
            </div>
            <div class="col-5" style="display:flex;">
                <cv-generic-export [disabled]="disabled" [items]="items" [fileName]="getLocalizedMessage('Challenge_History','Challenges History')"></cv-generic-export>
                <div class="search-box live-search">
                    <input type="search" class="form-control" name="CustomFilter" [(ngModel)]="search" (ngModelChange)="filterChanged()" cvLocalizedPlaceholder langSection="Users" langKey="Search" autocomplete="off" maxlength="40"/>
                    <span class="clear-input" [hidden]="search.length == 0" (click)="clearFilter()"></span>
                </div>
            </div>
        </div>
        
        <div class="performanceContent w-100 mx-auto" [hidden]="isLoading">
            <div class="challengesManagement">
                <ag-grid-angular #challengesHistoryGrid *ngIf="historyTable" class="performanceTable ag-theme-balham flex-fill" style="height: 600px" [gridOptions]="historyTable"></ag-grid-angular>
            </div>
        </div>
    </div>

    <div class="loadView challengesLoading mt-2" style="height: 30vh" [hidden]="!isLoading"></div>
</div>